// extracted by mini-css-extract-plugin
export default {"newBadge":"lGUDch"};